<!-- ══ En-tête de page ══════════════════════════════════════════════ -->
 

<section class="cuspage-hero">
        <div class="cuspage-hero__bg" ></div>
        <div class="container">
            <div class="cuspage-hero__content">
                <span class="cuspage-hero__tagline" style="display:none;">
                    <i class="icofont-justice-hammer"></i>
                    {{ 'CONTACT' | translate }}
                </span>
                <h1 class="cuspage-hero__title">{{ 'CONTACT' | translate }}</h1>
                <p class="cuspage-hero__sub">  </p>  
            </div>
        </div>
    </section>

<!-- ══ SECTION 1 — Coordonnées ══════════════════════════════════════ -->
<section class="contact-info-section">
    <div class="container">

        <div class="sec-title text-center wow fadeInUp" data-wow-delay="100ms"> 
            <h3 class="sec-title__title">{{ 'contact_info_titre' | translate }}</h3>
        </div>

        <!-- ng-container réduit settings de "SiteSetting|null" à "SiteSetting" -->
        <ng-container *ngIf="settings as s">
        <div class="row gutter-y-30 justify-content-center mt-5">

            <!-- Adresse -->
            <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="100ms">
                <div class="contact-info-card">
                    <div class="contact-info-card__icon">
                        <i class="icofont-location-pin"></i>
                    </div>
                    <h4 class="contact-info-card__title">{{ 'contact_adresse' | translate }}</h4>
                    <p *ngIf="s.adresse_text || pickLang(s.adresse)">{{ s.adresse_text || pickLang(s.adresse) }}</p>
                    <p *ngIf="s.adresse2_text || pickLang(s.adresse2)">{{ s.adresse2_text || pickLang(s.adresse2) }}</p>
                    <p *ngIf="!(s.adresse_text || pickLang(s.adresse))" class="contact-info-card__placeholder">—</p>
                </div>
            </div>

            <!-- Téléphone -->
            <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="200ms">
                <div class="contact-info-card">
                    <div class="contact-info-card__icon">
                        <i class="icofont-phone"></i>
                    </div>
                    <h4 class="contact-info-card__title">{{ 'contact_telephone' | translate }}</h4>
                    <p *ngIf="s.telephone">
                        <a [href]="'tel:' + s.telephone" class="contact-info-card__link">
                            {{ s.telephone }}
                        </a>
                    </p>
                    <p *ngIf="!s.telephone" class="contact-info-card__placeholder">—</p>
                </div>
            </div>

            <!-- Email -->
            <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="300ms">
                <div class="contact-info-card">
                    <div class="contact-info-card__icon">
                        <i class="icofont-envelope"></i>
                    </div>
                    <h4 class="contact-info-card__title">{{ 'contact_email' | translate }}</h4>
                    <ng-container *ngIf="s.email || s.email_contact as contactEmail">
                        <p>
                            <a [href]="'mailto:' + contactEmail" class="contact-info-card__link">
                                {{ contactEmail }}
                            </a>
                        </p>
                    </ng-container>
                    <p *ngIf="!s.email && !s.email_contact" class="contact-info-card__placeholder">—</p>
                </div>
            </div>

            <!-- Réseaux sociaux -->
            <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="400ms">
                <div class="contact-info-card">
                    <div class="contact-info-card__icon">
                        <i class="icofont-social-media"></i>
                    </div>
                    <h4 class="contact-info-card__title">{{ 'contact_reseaux' | translate }}</h4>
                    <div class="contact-socials">
                        <a *ngIf="s.facebook"  [href]="s.facebook"  target="_blank" rel="noopener" class="contact-socials__link contact-socials__link--fb">
                            <i class="icofont-facebook"></i>
                        </a>
                        <a *ngIf="s.twitter"   [href]="s.twitter"   target="_blank" rel="noopener" class="contact-socials__link contact-socials__link--tw">
                            <i class="icofont-twitter"></i>
                        </a>
                        <a *ngIf="s.linkedin"  [href]="s.linkedin"  target="_blank" rel="noopener" class="contact-socials__link contact-socials__link--li">
                            <i class="icofont-linkedin"></i>
                        </a>
                        <a *ngIf="s.instagram" [href]="s.instagram" target="_blank" rel="noopener" class="contact-socials__link contact-socials__link--ig">
                            <i class="icofont-instagram"></i>
                        </a>
                        <p *ngIf="!hasSocials" class="contact-info-card__placeholder">—</p>
                    </div>
                </div>
            </div>

        </div>
        </ng-container>
    </div>
</section>


<!-- ══ SECTION 2 — Formulaire ═══════════════════════════════════════ -->
<section class="arp-form-section contact-form-section">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-xl-8 col-lg-9">

                <!-- ── Succès ── -->
                <div *ngIf="submitted" class="arp-success wow fadeInUp">
                    <div class="arp-success__icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                            <path d="M9 12l2 2 4-4M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"
                                  stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <h3>{{ 'contact_succes_titre' | translate }}</h3>
                    <p>{{ 'contact_succes_msg' | translate }}</p>
                    <div class="arp-success__actions">
                        <button class="careox-btn" (click)="reset()">
                            <span>{{ 'contact_nouveau' | translate }}</span>
                        </button>
                        <a routerLink="/" class="careox-btn careox-btn--ghost">
                            <span>{{ 'accueil' | translate }}</span>
                        </a>
                    </div>
                </div>

                <!-- ── Formulaire ── -->
                <div *ngIf="!submitted">
                    <div class="sec-title wow fadeInUp" data-wow-delay="100ms">
                        <span class="sec-title__tagline">{{ 'contact_form_tagline' | translate }}</span>
                        <h3 class="sec-title__title">{{ 'contact_form_titre' | translate }}</h3>
                        <p class="sec-title__text">{{ 'contact_form_sous_titre' | translate }}</p>
                    </div>

                    <form class="arp-form wow fadeInUp" data-wow-delay="200ms"
                          (ngSubmit)="onSubmit()" novalidate [class.rtl]="isRtl">

                        <!-- Erreur globale -->
                        <div *ngIf="error" class="arp-alert-error">{{ error }}</div>

                        <!-- Section identité -->
                        <div class="arp-form__section">
                            <h5 class="arp-form__section-title">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"
                                          stroke-linecap="round"/>
                                </svg>
                                {{ 'contact_section_identite' | translate }}
                            </h5>

                            <div class="row">
                                <!-- Nom -->
                                <div class="col-md-6 mb-3">
                                    <label class="arp-label">
                                        {{ 'contact_nom' | translate }}<span class="req">*</span>
                                    </label>
                                    <div [class.has-error]="isInvalid('name')">
                                        <input type="text"
                                               class="arp-input w-100"
                                               [(ngModel)]="form.name"
                                               name="name"
                                               [placeholder]="'contact_nom_ph' | translate"
                                               (blur)="touch('name')" />
                                        <span class="arp-err" *ngIf="isInvalid('name')">
                                            {{ 'commun_champ_requis' | translate }}
                                        </span>
                                    </div>
                                </div>

                                <!-- Email -->
                                <div class="col-md-6 mb-3">
                                    <label class="arp-label">
                                        {{ 'contact_email_label' | translate }}<span class="req">*</span>
                                    </label>
                                    <div [class.has-error]="isEmailInvalid()">
                                        <input type="email"
                                               class="arp-input w-100"
                                               [(ngModel)]="form.email"
                                               name="email"
                                               [placeholder]="'contact_email_ph' | translate"
                                               (blur)="touch('email')" />
                                        <span class="arp-err" *ngIf="isEmailInvalid()">
                                            {{ 'contact_email_invalide' | translate }}
                                        </span>
                                    </div>
                                </div>

                                <!-- Téléphone (optionnel) -->
                                <div class="col-md-6 mb-3">
                                    <label class="arp-label">
                                        {{ 'contact_telephone_label' | translate }}
                                        <span class="optional">({{ 'contact_optionnel' | translate }})</span>
                                    </label>
                                    <input type="tel"
                                           class="arp-input w-100"
                                           [(ngModel)]="form.phone"
                                           name="phone"
                                           [placeholder]="'contact_tel_ph' | translate" />
                                </div>

                                <!-- Sujet -->
                                <div class="col-md-6 mb-3">
                                    <label class="arp-label">
                                        {{ 'contact_sujet' | translate }}<span class="req">*</span>
                                    </label>
                                    <div [class.has-error]="isInvalid('subject')">
                                        <input type="text"
                                               class="arp-input w-100"
                                               [(ngModel)]="form.subject"
                                               name="subject"
                                               [placeholder]="'contact_sujet_ph' | translate"
                                               (blur)="touch('subject')" />
                                        <span class="arp-err" *ngIf="isInvalid('subject')">
                                            {{ 'commun_champ_requis' | translate }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Section message -->
                        <div class="arp-form__section">
                            <h5 class="arp-form__section-title">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
                                          stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                {{ 'contact_section_message' | translate }}
                            </h5>

                            <div [class.has-error]="isInvalid('message')">
                                <textarea class="arp-input arp-textarea w-100"
                                          [(ngModel)]="form.message"
                                          name="message"
                                          rows="6"
                                          [placeholder]="'contact_message_ph' | translate"
                                          (blur)="touch('message')"></textarea>
                                <span class="arp-err" *ngIf="isInvalid('message')">
                                    {{ 'commun_champ_requis' | translate }}
                                </span>
                            </div>
                        </div>

                        <!-- Section captcha -->
                        <div class="arp-form__section contact-captcha-section">
                            <h5 class="arp-form__section-title">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke-linecap="round"/>
                                    <path d="M7 11V7a5 5 0 0 1 10 0v4" stroke-linecap="round"/>
                                </svg>
                                {{ 'contact_captcha_titre' | translate }}
                            </h5>

                            <div class="contact-captcha">
                                <div class="contact-captcha__question">
                                    <span class="contact-captcha__num">{{ captchaA }}</span>
                                    <span class="contact-captcha__op">+</span>
                                    <span class="contact-captcha__num">{{ captchaB }}</span>
                                    <span class="contact-captcha__op">=</span>
                                    <span class="contact-captcha__q">?</span>
                                </div>
                                <div class="contact-captcha__input-wrap" [class.has-error]="isCaptchaInvalid()">
                                    <input type="number"
                                           class="arp-input contact-captcha__input"
                                           [(ngModel)]="form.captcha"
                                           name="captcha"
                                           min="0"
                                           [placeholder]="'contact_captcha_ph' | translate"
                                           (blur)="touch('captcha')" />
                                    <button type="button" class="contact-captcha__refresh"
                                            (click)="newCaptcha()"
                                            [title]="'contact_captcha_refresh' | translate">
                                        <i class="icofont-refresh"></i>
                                    </button>
                                </div>
                                <span class="arp-err" *ngIf="isCaptchaInvalid()">
                                    {{ 'contact_captcha_erreur' | translate }}
                                </span>
                            </div>
                        </div>

                        <!-- Boutons -->
                        <div class="contact-form__actions">
                            <button type="submit"
                                    class="careox-btn"
                                    [disabled]="sending">
                                <span *ngIf="!sending">{{ 'contact_envoyer' | translate }}</span>
                                <span *ngIf="sending">{{ 'contact_envoi' | translate }}</span>
                            </button>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    </div>
</section>


<!-- ══ SECTION 3 — Carte ════════════════════════════════════════════ -->
<section class="contact-map-section">
    <div class="contact-map-wrapper">
        <iframe
            [src]="mapUrl"
            class="contact-map-iframe"
            width="100%"
            height="480"
            style="border:0"
            allowfullscreen
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
            title="{{ 'contact_carte' | translate }}">
        </iframe>
    </div>
</section>
